var _defs, _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle3, _path16, _path17, _path18, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLogoAbled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{font-size:32.14px;fill:#a09f9f;font-family:Philosopher-Regular, Philosopher;}.cls-23{letter-spacing:-0.07em;}.cls-24{letter-spacing:-0.01em;}.cls-25{letter-spacing:-0.01em;}.cls-26{letter-spacing:0em;}.cls-27{letter-spacing:-0.05em;}.cls-28{letter-spacing:-0.01em;}.cls-29{letter-spacing:-0.01em;}.cls-30{letter-spacing:-0.01em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 75.19,
    y1: 75.27,
    x2: 88.91,
    y2: 75.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#882935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a42731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#be252d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d2232b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e02229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e92127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb2127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3953.83,
    y1: -2212.77,
    x2: 3967.54,
    y2: -2212.77,
    gradientTransform: "translate(-2080.22 -3830.48) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1665.79,
    y1: -6091.4,
    x2: 1679.5,
    y2: -6091.4,
    gradientTransform: "translate(1750.26 -5910.71) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2212.85,
    y1: -3803.36,
    x2: -2199.13,
    y2: -3803.36,
    gradientTransform: "translate(3830.48 -2080.22) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2488.52,
    y1: -265.41,
    x2: 2502.24,
    y2: -265.41,
    gradientTransform: "translate(-1833.48 -1484.54) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3613.25,
    y1: -4625.94,
    x2: 3626.97,
    y2: -4625.94,
    gradientTransform: "translate(-595.68 -5663.96) rotate(135)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -747.28,
    y1: -5750.67,
    x2: -733.57,
    y2: -5750.67,
    gradientTransform: "translate(3583.74 -4426.17) rotate(-135)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1872.01,
    y1: -1390.14,
    x2: -1858.3,
    y2: -1390.14,
    gradientTransform: "translate(2345.94 -246.75) rotate(-45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3425.36,
    y1: -1106.61,
    x2: 3439.08,
    y2: -1106.61,
    gradientTransform: "matrix(0.38, 0.93, -0.93, 0.38, -2192.06, -2649.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2772.78,
    y1: -5562.48,
    x2: 2786.49,
    y2: -5562.48,
    gradientTransform: "matrix(-0.93, 0.38, -0.38, -0.93, 569.03, -6022.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1683.09,
    y1: -4909.89,
    x2: -1669.38,
    y2: -4909.89,
    gradientTransform: "matrix(-0.38, -0.93, 0.93, -0.38, 3942.32, -3261.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1030.51,
    y1: -454.02,
    x2: -1016.79,
    y2: -454.02,
    gradientTransform: "matrix(0.93, -0.38, 0.38, 0.93, 1181.23, 111.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4024.94,
    y1: -3437.14,
    x2: 4038.66,
    y2: -3437.14,
    gradientTransform: "matrix(-0.38, 0.93, -0.93, -0.38, -1531.03, -4881.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 441.07,
    y1: -6163.44,
    x2: 454.78,
    y2: -6163.44,
    gradientTransform: "matrix(-0.93, -0.38, 0.38, -0.93, 2801.76, -5361.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2285.24,
    y1: -2579.57,
    x2: -2271.52,
    y2: -2579.57,
    gradientTransform: "matrix(0.38, -0.93, 0.93, 0.38, 3281.29, -1028.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1298.64,
    y1: 146.74,
    x2: 1312.35,
    y2: 146.74,
    gradientTransform: "matrix(0.93, 0.38, -0.38, 0.93, -1051.5, -549.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 119.33,
    y1: 67.29,
    x2: 137.52,
    y2: 67.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 14.54,
    y1: 178.55,
    x2: 32.73,
    y2: 178.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 119.33,
    y1: 44.37,
    x2: 137.52,
    y2: 44.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 119.33,
    y1: 21.45,
    x2: 137.52,
    y2: 21.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 142.24,
    y1: 21.45,
    x2: 160.44,
    y2: 21.45,
    xlinkHref: "#linear-gradient"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 82.05,
    cy: 75.27,
    r: 6.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.55,137.06a6.86,6.86,0,1,1,6.86-6.86A6.86,6.86,0,0,1,132.55,137.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.76,180.7a6.86,6.86,0,1,1,6.86,6.86A6.86,6.86,0,0,1,70.76,180.7Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.12,
    cy: 125.77,
    r: 6.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.53,97.12a6.86,6.86,0,1,1,0-9.69A6.86,6.86,0,0,1,123.53,97.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.69,171.67a6.86,6.86,0,1,1,9.7,0A6.84,6.84,0,0,1,110.69,171.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.14,158.84a6.86,6.86,0,1,1,0,9.7A6.86,6.86,0,0,1,36.14,158.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49,84.29a6.86,6.86,0,1,1-9.7,0A6.87,6.87,0,0,1,49,84.29Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.07,116.46a6.86,6.86,0,1,1,3.76-8.94A6.85,6.85,0,0,1,132.07,116.46Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M91.36,180.22A6.86,6.86,0,1,1,100.3,184,6.86,6.86,0,0,1,91.36,180.22Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.6,139.51a6.85,6.85,0,1,1-3.76,8.94A6.84,6.84,0,0,1,27.6,139.51Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.31,75.75A6.85,6.85,0,1,1,59.37,72,6.85,6.85,0,0,1,68.31,75.75Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M125.21,156.3a6.86,6.86,0,1,1,8.94-3.75A6.85,6.85,0,0,1,125.21,156.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M51.51,173.36a6.86,6.86,0,1,1,3.76,8.94A6.87,6.87,0,0,1,51.51,173.36Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M34.46,99.66a6.86,6.86,0,1,1-8.94,3.76A6.86,6.86,0,0,1,34.46,99.66Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M108.16,82.6a6.86,6.86,0,1,1-3.76-8.94A6.86,6.86,0,0,1,108.16,82.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M137.52,67.29a9.1,9.1,0,1,1-9.09-9.1A9.1,9.1,0,0,1,137.52,67.29Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 23.63,
    cy: 178.55,
    r: 9.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M137.52,44.37a9.1,9.1,0,1,1-9.09-9.1A9.09,9.09,0,0,1,137.52,44.37Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M137.52,21.45a9.1,9.1,0,1,1-9.09-9.1A9.09,9.09,0,0,1,137.52,21.45Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M160.44,21.45a9.1,9.1,0,1,1-9.1-9.1A9.09,9.09,0,0,1,160.44,21.45Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(172.96 94.3)"
  }, "Aura ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 73.84,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 92.07,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 108.62,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 124.94,
    y: 0
  }, "ages "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38.56
  }, "Abled "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 85.54,
    y: 38.56
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 102.67,
    y: 38.56
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 115.43,
    y: 38.56
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 130.56,
    y: 38.56
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 146.28,
    y: 38.56
  }, "elers"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 77.12
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 17.74,
    y: 77.12
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 30.21,
    y: 77.12
  }, "ogram"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoAbled);
export default __webpack_public_path__ + "static/media/ImgLogoAbled.d8836aeecbfb0c109d08b64f4cdde29d.svg";
export { ForwardRef as ReactComponent };